import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { Lang } from '../../../models/lang';
import { Strings } from '../../../const/strings';
import { DOCUMENT } from '@angular/common';
import { LangService } from '../../../services/lang.service';
import { Brand } from '../../../models/brand';
import { CarPagination } from 'src/app/models/car';

type SortMenuTypes = 'sold' | 'brand';

@Component({
  selector: 'app-car-sort',
  templateUrl: './car-sort.component.html',
  styleUrls: ['./car-sort.component.scss']
})
export class CarSortComponent implements OnInit, OnDestroy {
  appUrl: string;
  lang: Lang;
  strings = Strings;

  @Input() isOpen: boolean;
  @Input() carPagination: CarPagination;
  @Input() isSortSelling: boolean;
  @Input() sortBrandId: string;
  @Input() brands: Brand[] = [];
  @Output() clickMenuButton = new EventEmitter();

  isSoldSortMenuOpened = false;
  isBrandSortMenuOpened = false;
  private documentClickListener = null;
  private keepSoldSortMenuListener = null;
  private keepBrandSortMenuListener = null;

  @ViewChild('soldSortMenuParent') soldSortMenuParentElement: ElementRef;
  @ViewChild('brandSortMenuParent') brandSortMenuParentElement: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private changeDetectorRef: ChangeDetectorRef,
    private langService: LangService,
  ) { }

  ngOnInit() {
    this.appUrl = this.langService.getAppUrl();
    this.lang = this.langService.getCurrentLang();
  }

  ngOnDestroy() {
    this.removeDocumentClickEvent();
  }

  tapMenu() {
    this.clickMenuButton.emit();
  }

  get hasPagination() {
    return this.carPagination.totalCount > this.carPagination.perPage;
  }

  get sellingQueryParams() {
    return  this.isSortSelling ? {selling: '1'} : {};
  }

  get sellingRouterLinkPath() {
    return this.sortBrandId ? `/makes/${this.sortBrandId}` : '/';
  }

  get brandSelectLabel() {
    if (this.sortBrandId) {
      const filteredBrand = this.brands.filter(brand => brand.id === this.sortBrandId)[0];
      if (filteredBrand) {
        return filteredBrand.name;
      }
    }
    return this.strings.carList.sortMaker[this.lang];
  }

  toggleSubMenu(type: SortMenuTypes) {
    switch (type) {
      case 'sold':
        const isOpened = this.isSoldSortMenuOpened;
        this.isSoldSortMenuOpened = !this.isSoldSortMenuOpened;
        this.isBrandSortMenuOpened = false;
        if (isOpened) {
          this.removeDocumentClickEvent();
        } else {
          this.clickAboutButton();
        }
        break;
      case 'brand':
        this.isBrandSortMenuOpened = !this.isBrandSortMenuOpened;
        this.isSoldSortMenuOpened = false;
        this.clickContentsButton();
        break;
    }
  }

  private clickAboutButton() {
    this.documentClickListener = this.closeSubMenu.bind(this);
    this.keepSoldSortMenuListener = this.keepSubMenu.bind(this);
    this.document.addEventListener('click', this.documentClickListener, false);
    this.soldSortMenuParentElement.nativeElement.addEventListener('click', this.keepSoldSortMenuListener, false);
  }

  private clickContentsButton() {
    this.documentClickListener = this.closeSubMenu.bind(this);
    this.keepBrandSortMenuListener = this.keepSubMenu.bind(this);
    this.document.addEventListener('click', this.documentClickListener, false);
    this.brandSortMenuParentElement.nativeElement.addEventListener('click', this.keepBrandSortMenuListener, false);
  }

  private removeDocumentClickEvent() {
    this.document.removeEventListener('click', this.documentClickListener);
    if (this.keepSoldSortMenuListener) {
      this.isSoldSortMenuOpened = false;
      this.soldSortMenuParentElement.nativeElement.removeEventListener('click', this.keepSoldSortMenuListener);
    }
    if (this.keepBrandSortMenuListener) {
      this.isBrandSortMenuOpened = false;
      this.brandSortMenuParentElement.nativeElement.removeEventListener('click', this.keepBrandSortMenuListener);
    }
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges();
  }

  private closeSubMenu() {
    this.removeDocumentClickEvent();
  }

  private keepSubMenu(e) {
    e.stopPropagation();
  }


}
